export var SHOW_MORE = "Show More";
export var SHOW_LESS = "Show Less";